import React, { Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Page from '../page';
import BookContent from './book-content';
import BookSidebar from './book-sidebar';
import * as api from '../../../../utilities/api';
import { fetchXML } from '../../../../utilities/xml';
import XMLTransform from '../../../../utilities/xml-transform';
import {isEmpty} from '../../../../utilities/validation';
import {arrayToIdKeyedObject, decimaltoHex} from '../../../../utilities/common';
import {fetchMyAssignment} from '../../../../actions/jre';
import {formatErrors} from '../../../../actions/errors';
import CommonModal from '../../../common/CommonModal';
import {addFlashMessage} from '../../../../actions/jre';
import {gradeModuleGradeItem,playercloseandsubmitcalling} from '../../../../utilities/api';
import SelfMarkForm from './SelfMarkForm';
import {FormErrors} from '../../../common';
import SweetAlert from 'sweetalert2-react';
import {saveAnswer, saveAnswers} from '../../../../actions/jre';
import ExtendedContentSidebar from './ExtendedContentSidebar';

const getActiveNodeId = function(nodeId, nodes = []) {
    const firstNodeId = (nodes.length) ? nodes[0].id : '';
    return (nodeId) ? nodeId : firstNodeId;
};

const getEmptyPageContent = function() {
    return { texts: [], videos: [] };
};

// Angular iframe URL path index 12: 0 = hide Engagement Survey, 1 = show
const getEngagementSurveyStatus = () => {
    let contentparams = window.contentparams;
    if (!contentparams) {
        try {
            contentparams = JSON.parse(localStorage.getItem('contentparams'));
        } catch (e) {
            contentparams = null;
        }
    }
    return Number(contentparams && contentparams[12]);
};

// analytics-track-start: iframe analytics helper for Book route
const postAnalyticsMessage = (eventName, props = {}) => {
    if (window.parent && window.parent !== window) {
        window.parent.postMessage(
            {
                type: 'analytics',
                event: eventName,
                props
            },
            '*'
        );
    }
};
// analytics-track-end

class Book extends React.Component {
    constructor(props) {
        super(props);

        const {
            bookId = '',
            sectionId = '',
            extendedContentId = null,
            pageNum = 1
        } = props.match.params;

        this.state = {
            bookId,
            assetID: '',
            moduleType:'',
            sectionId,
            pageNum: 1,
            sections: [],
            content: getEmptyPageContent(),
            title: '',
            bookStyle: {},
            prevBtnDisabled: false, // used to disable prevBtn when there are no pages to go back to
            nextBtnDisabled: false, // used to disable nextBtn when there are no pages to go forward to
            selectedIndex: 0,
            moduleURL: '',
            moduleID: '',
            assignmentId: '',
            pageCount: 0,
            sessionNum: 1,
            moduleProgress: {},
            progress: {},
            latestPage: 0,
            sessionComplete: false,
            collapsed:false,
            extendedContent: {},
            extendedContentId,
            extendedContentVisible: true,
            extendedContentEditing: false, // set in componentDidMount, based on "edit" query param
            extendedContentPreviewing: false, // set in componentDidMount, based on "preview" query param
            extendedContentModified: false,
            showEditorModalProps: false,
            targetPageExtendedContent: 0,
            extendedContentExitAction: false,
            extendedContentSectionTarget:{},
            submitting: false, // used to disable JRE navigation buttons when when data (ie, extended content) is
            //  being submitted to the BE
            takingAssessment: false, // used to disable AppPlayerComponent and BookSideBar buttons when a student is
            // taking an Assessment (ie Module Guide, RCA(s), posttest) CS-85
            preventMultiClick: true,
            requiredNodeNotCompleted: false,
            showGradingModal: false,
            errors: {},
            attendanceToggle: false,
            participationToggle: false,
            showSuccessModal: false,
            sectionMarked: false,
            studentInput: {},
            assignmentInfo: {},
            assignment: {},
            pageId: null,
            submitMarksdata : {}, // Naren
            knownAssessmentNames: ['Module Guide', 'RCA', 'RCA 1', 'RCA 2', 'RCA 3', 'RCA 4', 'RCA 5', 'RCA 6', 'Post Test','Pop Quiz 1','Pop Quiz 2','Pop Quiz 3','Pop Quiz 4','Pop Quiz 5','Pop Quiz 6','Pop Quiz 7','Pop Quiz 8','Pop Quiz 9','Pop Quiz 10'],
            isExitingViewer : false, // used to show SelfMarkForm Modal when student exits the module viewer CS-68
        };
        this.updateStudentProgress = this.updateStudentProgress.bind(this);
        this.collapseSidebar = this.collapseSidebar.bind(this);
        this.collapseExtendedContentSidebar = this.collapseExtendedContentSidebar.bind(this);
        this.onCloseSuccessModal = this.onCloseSuccessModal.bind(this);
        this.onSubmitMarks = this.onSubmitMarks.bind(this);
        this.audioEnded = this.audioEnded.bind(this);
        this.fetchExtendedContent = this.fetchExtendedContent.bind(this);
        this.extendedContentHtmlChanged = this.extendedContentHtmlChanged.bind(this);
        this.showUnsavedExtendedContentModal = this.showUnsavedExtendedContentModal.bind(this);
        this.handleUnsavedExtendedContent = this.handleUnsavedExtendedContent.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.enableJREAppPlayerContainerButtons = this.enableJREAppPlayerContainerButtons.bind(this);
        this.disableJREAppPlayerContainerButtons = this.disableJREAppPlayerContainerButtons.bind(this);

        this.gradingModal = this.gradingModal.bind(this); // Naren
        this.handlechange = this.handlechange.bind(this); // Naren
    }

    handlechange(attendance,participation)
    {

     let att1_count = attendance.map((element) => element.attendance1);
     let att2_count = attendance.map((element) => element.attendance2);
     let part1_count = participation.map((element) => element.participation1);
     let part2_count = participation.map((element) => element.participation2);


      let att1_value = att1_count.filter(function(element){return element});
      let part1_value = part1_count.filter(function(element){ return element});
      let att2_value = att2_count.filter(function(element){ return element});
      let part2_value = part2_count.filter(function(element){ return element});

      let attendance1 = (att1_value.length>0)?att1_value[att1_value.length-1]:att1_value[att1_value.length];
      let participation1 = (part1_value.length>0)?part1_value[part1_value.length-1]:part1_value[part1_value.length];
      let attendance2 = (att2_value.length>0)?att2_value[att2_value.length-1]:att2_value[att2_value.length];
      let participation2 = (part2_value.length>0)?part2_value[part2_value.length-1]:part2_value[part2_value.length];

      let data = {
        attendance1 : attendance1,
        participation1 : participation1,
        attendance2: attendance2,
        participation2 : participation2
      }

      this.setState({submitMarksdata:data});
    }

    UNSAFE_componentWillMount() {
        // console.log("componentWillMount - book");
        // console.log(localStorage.getItem('contentparams'));
        window.contentparams = JSON.parse(localStorage.getItem('contentparams')); //Naren
    }

    componentDidMount() {
        // console.log("book index");
        if(localStorage.getItem('pointpossiblefromapi') != null){
            localStorage.removeItem('pointpossiblefromapi');
        }

        if(localStorage.getItem('pointpossiblefromapiuser2') != null){
            localStorage.removeItem('pointpossiblefromapiuser2');
        }

        if(localStorage.getItem('pointValue') != null){
            localStorage.removeItem('pointValue');
        }

        const {bookId = '', sectionId = '', pageNum = 1, assignmentId = '', extendedContentId = '',studentId} = this.props.match.params;
        const {fetchMyAssignment, formatErrors, role} = this.props;
        //if (role === 'student') {

            fetchMyAssignment(assignmentId).then(result => {
                let assignmentInfo = {};
                assignmentInfo['users'] = result.assignment.users.map(user => {
                    return {
                        //name: user.first_name + ' ' + user.last_name,
                        name: user.firstName + ' ' + user.lastName,
                        username: user.username
                    };
                });
                assignmentInfo['classroom'] = result.assignment.classroom.name;
                assignmentInfo['content'] = result.assignment.content.name;

                // console.log("fetchMyAssignment setState");
                this.setState({
                    assignment: result.assignment,
                    assignmentInfo: assignmentInfo,
                    extendedContent: result.assignment.extendedContentPackage,
                    progress:result.assignment.progress,
                    attendanceToggle:result.assignment.moduleToggles.attendanceToggle,
                    participationToggle:result.assignment.moduleToggles.participationToggle,
                    users:result.assignment.users,
                    moduleType:result.assignment.moduletype
                });

                if(result.assignment.users[0].pointPossible != undefined){
                    localStorage.setItem('pointpossiblefromapi',result.assignment.users[0].pointPossible);
                }

                if(result.assignment.users[0].point_possible != undefined){
                    localStorage.setItem('pointpossiblefromapi',result.assignment.users[0].point_possible);
                }

                if(result.assignment.users[1] != undefined){
                    if(result.assignment.users[1].pointPossible != undefined){
                        localStorage.setItem('pointpossiblefromapiuser2',result.assignment.users[1].pointPossible);
                    }

                    if(result.assignment.users[1].point_possible != undefined){
                        localStorage.setItem('pointpossiblefromapiuser2',result.assignment.users[1].point_possible);
                    }
                }



            })
                .catch(err => formatErrors(err, '/assignments'))

                // Naren api.trackContentStudent({contentId: bookId}); // We want to track any time a student opens a module
        //}

        api.fetchContent(bookId, {assignmentId},window.contentparams).then(result => {
            let studentInput = null;

            if(!isEmpty(result.content.moduleProgress)){
                studentInput = result.content.moduleProgress[0].studentInput;
                if(result.content.moduleProgress.length > 1 &&
                    Object.keys(result.content.moduleProgress[1].studentInput).length >
                    Object.keys(result.content.moduleProgress[0].studentInput).length
                )
                {
                    studentInput = result.content.moduleProgress[1].studentInput;
                }
            }

          window.contentparams[8] = result.content.moduleProgress[0].lastreadpage;
          window.contentparams[7] = pageNum;
          localStorage.setItem('contentparams',JSON.stringify(window.contentparams));
        //   console.log("fetchContent setState");
            this.setState({
                moduleURL: result.content.url,
                assetID: result.content.assetId,
                moduleID: bookId,
                extendedContentId: extendedContentId,
                assignmentId: assignmentId,
                pageNum: pageNum,
                moduleProgress: result.content.moduleProgress,
                studentInput: studentInput,
                lastreadPage: result.content.moduleProgress[0].lastreadpage,
                extendedContent: result.content.extendedContentPackage
            });
            // console.log("before fetchBook");
            this.fetchBook(bookId, sectionId, pageNum);
        }).catch(err => formatErrors(err, '/assignments'));

        if(!isEmpty(extendedContentId)){
            this.fetchExtendedContent(extendedContentId);
        }
        this.disableJREAppPlayerContainerButtons('preventMultiClick', 'book index componentDidMount');
        document.addEventListener('jre-audio-ended', this.audioEnded);

        // analytics-track-start: initial iframe page view
        postAnalyticsMessage('iframe_page_view', {
            page: window.location.pathname,
            contentType: 'html5',
            moduleId: bookId,
            assignmentId
        });
        // analytics-track-end
    }

    componentWillUnmount() {
        document.removeEventListener('jre-audio-ended', this.audioEnded);
        window.jreRestrictForwardSeek = false; //video-player forward seeking prevention
    }

    // eslint-disable-next-line no-unused-vars
    componentDidUpdate(prevProps, prevState, snapshot) {
        const {preventMultiClick, pageId, pageNum, sectionId, sectionTitle, sessionNum} = this.state;
        if(this.props !== prevProps){
            if(!preventMultiClick
                && prevState.pageId !== pageId
                && prevState.pageNum !== pageNum
                && prevState.sectionId !== sectionId
                && prevState.sectionTitle !== sectionTitle
                && prevState.sessionNum !== sessionNum
            ){
                this.disableJREAppPlayerContainerButtons('preventMultiClick', ' book index componentDidUpdate ');
            }
        }
        return this.state !== prevState;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {bookId = '', sectionId = '', pageNum = 1} = nextProps.match.params;
        if(!isEmpty(this.state.sections)) {
            if (bookId !== this.state.bookId) {
                this.setState({bookId, sectionId, pageNum});
                this.fetchBook(bookId, sectionId, pageNum);
                postAnalyticsMessage('iframe_page_view', {
                    page: window.location.pathname,
                    contentType: 'html5',
                    moduleId: bookId,
                    assignmentId: nextProps.match.params.assignmentId
                });
            } else if (sectionId !== this.state.sectionId) {
                this.selectPage(bookId, this.state.sectionId, pageNum, this.state.sections);
                postAnalyticsMessage('iframe_page_view', {
                    page: window.location.pathname,
                    contentType: 'html5',
                    moduleId: bookId,
                    assignmentId: nextProps.match.params.assignmentId
                });
            } else if (pageNum !== this.state.pageNum) {
                this.selectPage(bookId, this.state.sectionId, pageNum, this.state.sections);
                postAnalyticsMessage('iframe_page_view', {
                    page: window.location.pathname,
                    contentType: 'html5',
                    moduleId: bookId,
                    assignmentId: nextProps.match.params.assignmentId
                });
            }
            this.setPrevAndNextBtnState(pageNum);
        }
    }

    fetchExtendedContent(extendedContentId = null) {
        if(!extendedContentId || isEmpty(extendedContentId)) {
            extendedContentId = this.state.extendedContentId;
        }
        if(!extendedContentId || isEmpty(extendedContentId)) {
            extendedContentId = this.props.match.params.extendedContentId;
        }
        const {role} = this.props;
        const {pageNum} = this.state;

        if (extendedContentId && !isEmpty(extendedContentId) || role === 'school_admin' || role === 'teacher'){
            this.setState({
                extendedContentVisible: false,
                extendedContent: null
            });
            if(!isEmpty(extendedContentId)){
                api.fetchExtendedContent(extendedContentId,{pageNum,role},window.contentparams).then(result => {
                    const isEditing = this.props.location.search.includes('edit') ;
                    const isPreviewing = this.props.location.search.includes('preview') ;
                    if(!isEmpty(result)){
                        this.setState({
                            extendedContent: result.extendedContentPackage,
                            extendedContentEditing: isEditing,
                            extendedContentPreviewing: isPreviewing,
                            extendedContentVisible: true,
                        });
                    }
                }).catch(err => {
                    addFlashMessage(err.data.message, 'error');
                });
            }
        }
    }

    onCloseSuccessModal() {
        const {assignmentId='' } = this.props.match.params;
        const {role} = this.props;
        const {sessionNum, isExitingViewer} = this.state;

        window.contentparams[1] = sessionNum;  // Naren

        playercloseandsubmitcalling(window.contentparams).then(() => {
        //   console.log('success');
          window.parent.postMessage("child frame", "*"); // Naren
        // }, () => history.push('/assignment/' + assignmentId));  Naren
        window.location.href ='https://devapp.staracademyapp.com/assignments/list';
        window.top.location.href='https://devapp.staracademyapp.com/assignments/list';
        }).catch(err => formatErrors(err).then(err => {
            this.setState({
                errors: err,
            });
        }))

        this.setState({showSuccessModal: false});
        //this.props.history.push('/assignment/' + assignmentId);
        window.parent.postMessage("child frame", "*"); // Naren
        if(role === 'student'){ // joyson
          window.location.href ='https://devapp.staracademyapp.com/assignments/list';
          window.top.location.href='https://devapp.staracademyapp.com/assignments/list';
        }
    }

    onSubmitMarks() {
        let data = this.state.submitMarksdata; // Naren
        const {assignmentId='' } = this.props.match.params;
        const {formatErrors, users, history} = this.props;
        const {sessionNum, isExitingViewer} = this.state;

        window.contentparams[1] = sessionNum;  // Naren

        let tempGrades = [];
        const students = Object.values(users);

        if(!isEmpty(students[0]) && !isEmpty(data.attendance1)) {
            const pointsEarned = data.attendance1;
            tempGrades.push({
                userId: students[0].id,
                points: parseInt(pointsEarned),
                answers: []
            });
        }
        if(!isEmpty(students[1]) && !isEmpty(data.attendance2)) {
            const pointsEarned = data.attendance2;
            tempGrades.push({
                userId: students[1].id,
                points: parseInt(pointsEarned),
                answers: []
            });
        }

        let payload = {
            gradeType: `attendance_${sessionNum}`,
            assignmentId: assignmentId,
            grades: tempGrades
        };
        if(!isEmpty(tempGrades)){
            gradeModuleGradeItem(payload,window.contentparams).then( () => {
              tempGrades=[]
              playercloseandsubmitcalling(window.contentparams).then(() => {
                // console.log('success');
                window.parent.postMessage("child frame", "*"); // Naren
              // }, () => history.push('/assignment/' + assignmentId));  Naren
              window.location.href ='https://devapp.staracademyapp.com/assignments/list';
              window.top.location.href='https://devapp.staracademyapp.com/assignments/list';
              }).catch(err => formatErrors(err).then(err => {
                  this.setState({
                      errors: err,
                  });
              }))
            }).catch(err => formatErrors(err).then(err => {
                    this.setState({
                        errors: err,
                    });
            }));
        }

        tempGrades = []; // after submitting attendance points to BE, re-initialize tempGrades
        if(!isEmpty(students[0]) && !isEmpty(data.participation1)) {
            const pointsEarned = data.participation1;
            tempGrades.push({
                userId: students[0].id,
                points: parseInt(pointsEarned),
                answers: []
            });
        }
        if(!isEmpty(students[1]) && !isEmpty(data.participation2)) {
            const pointsEarned = data.participation2;
            tempGrades.push({
                userId: students[1].id,
                points: parseInt(pointsEarned),
                answers: []
            });
        }
        payload = {
            gradeType: `participation_${sessionNum}`,
            assignmentId: assignmentId,
            grades: tempGrades
        };
        if(!isEmpty(tempGrades)){
            gradeModuleGradeItem(payload,window.contentparams).then(() => {

                if(isExitingViewer){
                    this.setState({
                        showGradingModal: false,
                        isExitingViewer: false,
                      });
                }else{
                    this.setState({
                        showGradingModal: false,
                        showSuccessModal:true
                    });
                }
                playercloseandsubmitcalling(window.contentparams).then(() => {
                //   console.log('success');
                  window.parent.postMessage("child frame", "*"); // Naren
                // }, () => history.push('/assignment/' + assignmentId));  Naren
                window.location.href ='https://devapp.staracademyapp.com/assignments/list';
                window.top.location.href='https://devapp.staracademyapp.com/assignments/list';
                }).catch(err => formatErrors(err).then(err => {
                    this.setState({
                        errors: err,
                    });
                }))
            }).catch(err => formatErrors(err).then(err => {
                this.setState({
                    errors: err,
                });
            }));
        }

    }

    collapseSidebar() {
        this.setState({collapsed: !this.state.collapsed});
    }

    collapseExtendedContentSidebar() {
        const {extendedContentVisible} = this.state;
        const {role} = this.props;
        if(!extendedContentVisible && (role === 'teacher' || role === 'school_admin')) {
            this.fetchExtendedContent();
        }
        else {
            this.setState({extendedContentVisible: !extendedContentVisible});
        }
    }

    setPrevAndNextBtnState(pageNum) {
        const {sections, knownAssessmentNames} = this.state;
        let currentPageName = '';
        if(sections[this.state.selectedIndex] && sections[this.state.selectedIndex].pages[parseInt(pageNum)-1] &&
            !isEmpty(sections[this.state.selectedIndex].pages[parseInt(pageNum)-1]) &&
            sections[this.state.selectedIndex].pages[parseInt(pageNum)-1].title
            && !isEmpty(sections[this.state.selectedIndex].pages[parseInt(pageNum)-1].title)) {
            currentPageName = sections[this.state.selectedIndex].pages[parseInt(pageNum)-1].title;
        }
        let inAssessment = knownAssessmentNames.includes(currentPageName);

        if (this.state.sections.length < 1) {
            return;
        }
        const pagesLength = this.getPagesFromSection().length;
        let nextBtnDisabled = !(parseInt(pageNum) < pagesLength);
        const prevBtnDisabled = !(parseInt(pageNum) > 1);
        if(this.state.selectedIndex < 7 && (inAssessment) && this.state.selectedIndex !== 5){
            nextBtnDisabled = true;
        }

        this.setState(({nextBtnDisabled, prevBtnDisabled}));
    }

    refreshSlide() {
        const {bookId = '', sectionId = '', pageNum = 1,} = this.state;
        // console.log(this.state);
        if(!this.state.extendedContentModified){
            this.setState({bookId, sectionId, pageNum, content: getEmptyPageContent()});
            this.fetchBook(bookId, sectionId, pageNum);
        }else{
            this.setState({targetPageExtendedContent:pageNum});
            this.showUnsavedExtendedContentModal();
        }
    }

    moveToNextPage() {
        const {moduleID = '', sectionId = '', assignmentId, extendedContentId} = this.state;
        const role = this.props.role;
        // console.log(this.props.role);
        const nextPage = this.getNextPage();

        if(!this.state.extendedContentModified){
            this.setPrevAndNextBtnState(nextPage);
            // prevent multiclick
            this.disableJREAppPlayerContainerButtons('preventMultiClick', 'moveToNextPage() ');
            //this.selectPage(moduleID, sectionId, nextPage, this.state.sections);

            let pageLink = `/view/modules/${moduleID}/assignments/${assignmentId}/sections/${sectionId}/pages/${nextPage}`;
            if (extendedContentId){
                pageLink = `/view/modules/${moduleID}/assignments/${assignmentId}/sections/${sectionId}/pages/${nextPage}/extendid/${extendedContentId}`;
            } else if(role === 'student') {
                pageLink = `/view/modules/${moduleID}/assignments/${assignmentId}/sections/${sectionId}/pages/${nextPage}`;
            }

            this.props.history.push({pathname: pageLink, search: this.props.history.location.search});
        }else{
            this.setState({targetPageExtendedContent:nextPage});
            this.showUnsavedExtendedContentModal();
        }
    }

    moveToPreviousPage() {
        const {moduleID = '', sectionId = '', assignmentId, extendedContentId} = this.state;
        const previousPage = this.getPreviousPage();

        if(!this.state.extendedContentModified){
            this.setPrevAndNextBtnState(previousPage);
            //this.selectPage(moduleID, sectionId, previousPage, this.state.sections);
            // prevent multi-click
            this.disableJREAppPlayerContainerButtons('preventMultiClick', 'moveToPreviousPage() ');
            const role = this.props.role;

            let pageLink = `/view/modules/${moduleID}/assignments/${assignmentId}/sections/${sectionId}/pages/${previousPage}`;
            if (extendedContentId) {
                pageLink = `/view/modules/${moduleID}/assignments/${assignmentId}/sections/${sectionId}/pages/${previousPage}/extendid/${extendedContentId}`;
            } else if (role === 'student') {
                pageLink = `/view/modules/${moduleID}/assignments/${assignmentId}/sections/${sectionId}/pages/${previousPage}`;
            }

            this.props.history.push({pathname: pageLink, search: this.props.history.location.search});
        }else{
            this.setState({targetPageExtendedContent:previousPage});
            this.showUnsavedExtendedContentModal();
        }
    }

    getNextPage() {
        let {pageNum = 1} = this.state;
        const pagesLength = this.getPagesFromSection().length;

        if (parseInt(pageNum) + 1 >= parseInt(pagesLength)) {
            pageNum = pagesLength;
        } else {
            pageNum++;
        }

        return pageNum;
    }

    getActiveSection(sections, sectionId){
        // in the previous version of this code, with sections.find( section => (...)); there were cases where +1 to
        // the id would return the incorrect section that matched the (parseInt(sectionId) + 1).toString() ID
        // in the new code below, we check if the first condition is met first and break if successful, if we can't
        // find a match then we perform the +1 in a separate loop, this should also improve performance as the
        // second condition doesn't get evaluated and compared each time we fetch the section and its corresponding
        // pages

        // made this a stand alone function because I needed to use it as an utility function in getPagesFromSection
        // and in selectPage

        let foundMatch = false;
        for(let i=0; i<sections.length; i++){
            if(sections[i].id.toString() === sectionId.toString() ){
                foundMatch = true;
                return sections[i];
            }
        }
        if(!foundMatch){
            for(let i=0; i<sections.length; i++) {
                // the if conditional below was part of the original function, and I kept it in order not to
                // break any functionality which may be dependant on it
                if ((sections[i].id).toString() === (parseInt(sectionId) + 1).toString()) {
                    return sections[i];
                }
            }
        }else{
            return false;
        }
    }

    getPagesFromSection() {
        const {sections = [], sectionId = ''} = this.state;
        const activeSection = this.getActiveSection(sections, sectionId);

        if (activeSection) {
            return activeSection.pages;
        } else {
            return [];
        }
    }

    getPreviousPage() {
        let {pageNum = 1} = this.state;

        if (parseInt(pageNum) - 1 <= 1) {
            pageNum = 1;
        } else {
            pageNum--;
        }

        return pageNum;
    }

    audioEnded() {
        if (this.isGradableSectionForStudent() && this.isReadyForGrading()) {
            //this.setState({showGradingModal: true}); Naren
        }
    }

    exitViewer(){
        const {assignmentId='' } = this.props.match.params;
        const {role, history} = this.props;
        const {moduleType,moduleID,extendedContentModified, extendedContentEditing, sectionMarked = false, sectionId,
            sections,} = this.state;
        const { isExitingViewer} = this.state;


        const activeSection = this.getActiveSection(sections, sectionId);

        // if no session number exists, use 8 for enrichments


        let sessionNum = (activeSection.index || activeSection.index === 0)  ? (parseInt(activeSection.index) + 1) : 8;
        window.contentparams[1] = sessionNum;  // Naren



        if(extendedContentModified && extendedContentEditing) {
            this.showUnsavedExtendedContentModal();
            this.setState({extendedContentExitAction:true,});
        }else{
            if(role === 'student'){
              // alert(window.top.location.href+"window.top.location.href");
              // alert(window.parent.location.href+"window.parent.location.href");
              // alert(window.parent.location.pathname+"window.parent.location.pathname");
              // alert(window.parent.location.search.substring(1)+"window.parent.location.search.substring(1)");
              // alert('window.closing-checking');

              if(moduleType==7)
              {
                playercloseandsubmitcalling(window.contentparams).then(() => {
                //   console.log('success');
                  window.parent.postMessage("child frame", "*"); // Naren
                  window.close();
                  // window.location.href ='https://devapp.staracademyapp.com/assignments/list';//joyson
                  // window.top.location.href='https://devapp.staracademyapp.com/assignments/list';//joyson
                }).catch(err => formatErrors(err).then(err => {
                    this.setState({
                        errors: err,
                    });
                }))
              }
              else
              {
                // if(!sectionMarked && sessionNum < 8){
                if(!sectionMarked && sessionNum < 8 && role !== 'student'){
                    this.setState({isExitingViewer:true}, () =>{
                        if (this.isGradableSectionForStudent() && this.isReadyForGrading()) {
                            this.setState({showGradingModal: true});
                        }
                    });
                }else{
                  playercloseandsubmitcalling(window.contentparams).then(() => {
                    // console.log('success');
                    window.parent.postMessage("child frame", "*"); // Naren

                    window.close();
                    // window.location.href ='https://devapp.staracademyapp.com/assignments/list';//joyson
                    // window.top.location.href='https://devapp.staracademyapp.com/assignments/list';//joyson
                  }).catch(err => formatErrors(err).then(err => {
                      this.setState({
                          errors: err,
                      });
                  }))
                }
              }
            } else {
                //history.push('/modules/' + moduleID);
                  //window.parent.postMessage("child frame", "*"); // Naren
                  playercloseandsubmitcalling(window.contentparams).then(() => {
                    // console.log('success');
                    window.parent.postMessage("child frame", "*"); // Naren
                  }).catch(err => formatErrors(err).then(err => {
                      this.setState({
                          errors: err,
                      });
                  }))
            }
        }
    }

    isGradableSectionForStudent() {
        const {role = ''} = this.props;
        const {sectionTitle = ''} = this.state;
        return (sectionTitle.includes('Section') || sectionTitle.includes('Session')) && role === 'student';
    }

    changeSection(e) {
        const {moduleID = '', sections = [], assignmentId, extendedContentId,pageNum} = this.state;
        const role = this.props.role;
        const index = e.target.selectedIndex;
        const currentSection = sections[index];

        window.contentparams[1]=String(index+1);
        playercloseandsubmitcalling(window.contentparams).then(() => {
        //   console.log('success');
          // window.parent.postMessage("child frame", "*"); // Naren
          // window.close();
          // window.location.href ='https://devapp.staracademyapp.com/assignments/list';//joyson
          // window.top.location.href='https://devapp.staracademyapp.com/assignments/list';//joyson
        }).catch(err => formatErrors(err).then(err => {
            this.setState({
                errors: err,
            });
        }))
        api.fetchMyAssignment(assignmentId,window.contentparams).then(result => {
           let assignmentInfo = {};
           assignmentInfo['users'] = result.assignment.users.map(user => {
               return {
                   //name: user.first_name + ' ' + user.last_name,
                   name: user.firstName + ' ' + user.lastName,
                   username: user.username
               };
           });
           assignmentInfo['classroom'] = result.assignment.classroom.name;
           assignmentInfo['content'] = result.assignment.content.name;
           if(result.assignment.users[0].pointPossible != undefined){
            localStorage.setItem('pointpossiblefromapi',result.assignment.users[0].pointPossible);
            }

            if(result.assignment.users[0].point_possible != undefined){
                localStorage.setItem('pointpossiblefromapi',result.assignment.users[0].point_possible);
            }

           this.setState({
               assignment: result.assignment,
               assignmentInfo: assignmentInfo,
               progress:result.assignment.progress,
               attendanceToggle:result.assignment.moduleToggles.attendanceToggle,
               participationToggle:result.assignment.moduleToggles.participationToggle,
               users:result.assignment.users,
               moduleType:result.assignment.moduletype
           });

           let lastpagenum = (result.assignment.content.moduleProgress[0].lastreadpage != null || result.assignment.content.moduleProgress[0].lastreadpage != undefined )?result.assignment.content.moduleProgress[0].lastreadpage:1;
           if(lastpagenum==0)
           {
             lastpagenum=1;
           }
           window.contentparams[8] = lastpagenum;
           localStorage.setItem('contentparams',JSON.stringify(window.contentparams));

           if (this.isGradableSectionForStudent() && this.isReadyForGrading() && role !== 'student') {
               this.setState({showGradingModal: true});
           }
           else {
               let pageLink = `/view/modules/${moduleID}/assignments/${assignmentId}/sections/${currentSection.id}/pages/1`;
               if (extendedContentId) {
                   pageLink = `/view/modules/${moduleID}/assignments/${assignmentId}/sections/${currentSection.id}/pages/1/extendid/${extendedContentId}`;
               } else if(role === 'student') {
                   pageLink= `/view/modules/${moduleID}/assignments/${assignmentId}/sections/${currentSection.id}/pages/${lastpagenum}`;
               }
               if(!this.state.extendedContentModified){
                   this.setState({
                       selectedIndex: index,
                       sectionId: currentSection.id,
                       extendedContentVisible: true
                   }, function () {
                       this.selectPage(moduleID, currentSection.id, 1, sections);
                       this.props.history.push({pathname: pageLink, search: this.props.history.location.search});
                   });
               }else{
                   this.setState({extendedContentSectionTarget:currentSection});
                   this.showUnsavedExtendedContentModal();
               }
             }
       })
       .catch(err => formatErrors(err, '/assignments'));
     }

    isReadyForGrading() {
        const {attendanceToggle = false, sectionComplete = false, participationToggle = false,
            sectionMarked = false, isExitingViewer = false} = this.state;

        return (
            (!sectionMarked && sectionComplete && (attendanceToggle || participationToggle)) ||
            (!sectionMarked && isExitingViewer)
        );
    }

    gradingModal() {
        const {
            errors = {},
            attendanceToggle = false,
            participationToggle = false,
            sectionTitle = ''
        } = this.state;
        const {users} = this.props;
        return (
            <CommonModal
                title={`Enter Grades for ${sectionTitle}`}
                show={true}
                preventClose={true}
            >
                <FormErrors errors={errors}/>
                <SelfMarkForm
                    onSubmit={this.onSubmitMarks}
                    attendanceToggle={attendanceToggle}
                    participationToggle={participationToggle}
                    users={users}
                    handlechange = {this.handlechange}
                />
            </CommonModal>);
    }

    selectPage(bookId, sectionId, pageNum, sections=[]) {
        const {formatErrors, role, users} = this.props;
        let {moduleProgress, latestPage, progress, attendanceToggle, participationToggle} = this.state;

        if (!pageNum) {
            pageNum = 1;
        }

        let sessionNum='';

        latestPage = 1;
        let pageId = '';
        if (this.isValidPage(pageNum)) {
            pageId = this.getPagesFromSection()[pageNum - 1].id;
        }
        else {
            formatErrors('Page Number Out of Bounds', '/assignments');
        }

        const activeSectionId = getActiveNodeId(sectionId, sections);
        // console.log(sections);
        // console.log(sectionId);

        const activeSection = this.getActiveSection(sections, sectionId);
        // console.log(activeSection)

        sessionNum = (activeSection.index || activeSection.index===0  ? parseInt(activeSection.index) + 1 : 8);



        if (activeSection) {
            // MODULE PROGRESS
            let sectionComplete = false;
            if(role === 'student') {
                let students = Object.values(progress);
                const sectionMarked = students.every(student => {
                    return((!isEmpty(student[`attendance${sessionNum}`]) && attendanceToggle) &&
                        (!isEmpty(student[`participation${sessionNum}`]) && participationToggle));
                });
                this.setState({sectionMarked: sectionMarked});

                if(moduleProgress.length > 0 && !isEmpty(sections)) {
                    moduleProgress.map(studentModuleProgress => {

                        if(!isEmpty(users[0])) {  // Naren users[studentModuleProgress.userId]
                            if(latestPage <= parseInt(studentModuleProgress[`session_${sessionNum}_Page`])) {
                                latestPage = parseInt(studentModuleProgress[`session_${sessionNum}_Page`]);
                            }
                            if(studentModuleProgress[`session_${sessionNum}_Complete`]) {
                                sectionComplete = true;
                            }
                            if((pageNum >= activeSection.pages.length) && (sectionComplete === false)){
                                sectionComplete = true;
                            }
                        }
                    });
                    this.setState({latestPage: latestPage});
                    if(this.state.pageNum.toString() !== pageNum.toString()){
                        this.updateStudentProgress(pageNum, activeSection, latestPage, sectionComplete,users);
                    }
                }
                else {
                    this.updateStudentProgress('1', activeSection, '1', sectionComplete,users);
                }
            }
            // END MODULE PROGRESS
            let nextBtnDisabled = this.state.nextBtnDisabled;
            if(pageNum.toString() === latestPage.toString()){
                nextBtnDisabled = true;
            }

            this.setState({
                sectionId: activeSectionId,
                sectionTitle: activeSection.title,
                sessionNum: sessionNum,
                pageCount: activeSection.pages.length,
                sectionComplete: sectionComplete,
                latestPage: latestPage,
                pageNum: pageNum,
                nextBtnDisabled: nextBtnDisabled,
            });

            if (pageNum) {
                this.fetchPage(bookId, activeSectionId, pageId, pageNum, sessionNum, window.contentparams[1]);
            }
            else {
                this.setState({
                    pageNum: 1,
                    content: getEmptyPageContent()
                });
            }

            this.setPrevAndNextBtnState(pageNum);
            document.dispatchEvent(new Event('jre-select-page'));
            // this.updateStudentProgress(pageNum, activeSection);
            // Scroll to the top to show the updated content:
            window.scrollTo(0, 0);
        }
    }

    updateStudentProgress(pageNum, activeSection, latestPage, sessionCompleted, users) {
        let pageNumber = latestPage;
        if(parseInt(pageNum) >= latestPage) {
            pageNumber = parseInt(pageNum);
        }
        if(this.state.latestPage.toString() !== pageNumber.toString()) {
            this.setState({ latestPage: pageNumber.toString() });
        }
        const {bookId} = this.state;
        const {assignmentId='' } = this.props.match.params;
        // const sessionCompleted = parseInt(pageNum) >= activeSection.pages.length;

        // if no session number exists, use 8 for enrichments
        const sessionNum = (activeSection.index||activeSection.index===0  ? parseInt(activeSection.index) + 1 : 8);
        const payload = {
            moduleId: parseInt(bookId),
            sessionNum: sessionNum,
            pageNum: parseInt(pageNumber),
            completed: sessionCompleted,
            studentInput: {}
        };

        api.setModuleProgress(payload,window.contentparams).then(response => {
            response.module.moduleProgress.map(progress => {
                if(!isEmpty( progress.studentInput)){
                    for (const [key, value] of Object.entries(progress.studentInput)) {
                        this.props.saveAnswer({[key]: value},users);
                    }
                    let studentInput = progress.studentInput;
                    if(this.state.studentInput !== studentInput) {
                        this.setState({ studentInput: studentInput });
                    }
                }
            });
            if(this.state.moduleProgress !== response.module.moduleProgress) {
                this.setState({ moduleProgress: response.module.moduleProgress });
            }
        }).catch(err => formatErrors(err, `/view/modules/${bookId}/assignments/${assignmentId}`));
    }

    // Get default module style from base XML document
    getBookStyle(element) {
        const backgroundImage  = element.childNamed('background').val;
        const width = element.childNamed('background_width').val;
        const height = element.childNamed('background_height').val;
        const fontFamily = element.childNamed('font').val;
        let fontSize = element.childNamed('fontsize').val;
        fontSize = parseInt(parseFloat(fontSize) * 0.75);
        const fontStyle = element.childNamed('fontstyle').val;
        const color = `#${decimaltoHex(element.childNamed('fontcolor').val)}`;
        return {backgroundImage, width, height, fontFamily, fontSize, fontStyle, color};
    }

    fetchBook(bookId, sectionId, pageNum) {
        const moduleURL = this.state.moduleURL;
        const {formatErrors} = this.props;
        let sectionIdentifier = sectionId;
        // console.log(moduleURL);
        // console.log("fetchBook");
        // console.log('textarea');
        if(!isEmpty(moduleURL)){
            fetchXML(`${moduleURL}/book.xml`).then(xml => {
                // console.log(xml);
                const { title = '' } = xml.attr;
                let moduletype=xml.attr.content_type;
                const tocNode = xml.childNamed('toc');
                const bookStyle = this.getBookStyle(xml.childNamed('attributes'));

                const sectionNodes = tocNode.childrenNamed('section_node');
                let sections = [];
                let currentSectionIndex = 0;
                let enrichmentId = 0;
                sectionNodes.forEach((sectionNode, index) => {
                    let sectionTitle = sectionNode.attr.title;
                    const {id, title} = sectionNode.attr;
                    if(moduletype=='elaquest')
                    {
                      if(bookId=='61a65fb3f40f2b31faa5d329')
                      {
                        if(parseInt(sectionIdentifier) === (index + 1) && sectionId !== 13){
                            sectionIdentifier = id;
                            this.setState({sectionId: sectionIdentifier});
                        }
                      }
                      else
                      {
                        if(parseInt(sectionIdentifier) === (index + 1) && sectionId !== 9){
                            sectionIdentifier = id;
                            this.setState({sectionId: sectionIdentifier});
                        }
                      }
                    }
                    else
                    {
                      if(parseInt(sectionIdentifier) === (index + 1) && sectionId !==8){
                          sectionIdentifier = id;
                          this.setState({sectionId: sectionIdentifier});
                      }
                    }

                    let pages = [];
                    sectionNode.children.map(sectionChildNode => {
                        if (sectionChildNode.name === 'page_node') {
                            const {id, title} = sectionChildNode.attr;
                            pages.push({id, title});
                        }
                        else if (sectionChildNode.name === 'section_node' && (sectionChildNode.attr.title === 'Agent' || sectionTitle.includes('Session') || sectionTitle.includes('Section'))) {
                            sectionChildNode.children.map(subSectionChildNode => {
                                if (subSectionChildNode.name === 'page_node') {
                                    const {id, title} = subSectionChildNode.attr;
                                    pages.push({id, title});
                                }
                            });
                        }
                    });
                    if (getEngagementSurveyStatus() === 0) {
                        pages = pages.filter(p => p.title !== 'Engagement Survey');
                    }
                    if (pages.length > 0) {
                        sections.push({id, title, pages, index});
                    }
                    if (id === sectionIdentifier) {
                        currentSectionIndex = index;
                    }
                    const subSectionNodes = sectionNode.childrenNamed('section_node') || [];
                    subSectionNodes.forEach((subSectionNode, subSectionIndex) => {
                        const {id, title} = subSectionNode.attr;
                        if(moduletype=='elaquest')
                        {
                          if(bookId=='61a65fb3f40f2b31faa5d329')
                          {
                            if(enrichmentId === 0 && parseInt(sectionId) === 13 && !sectionTitle.includes('Chapter') && !sectionTitle.includes('Agent')){
                                enrichmentId = id;
                                sectionIdentifier = id;
                                this.setState({sectionId: sectionIdentifier});
                            }
                          }
                          else
                          {
                            if(enrichmentId === 0 && parseInt(sectionId) === 9 && !sectionTitle.includes('Chapter') && !sectionTitle.includes('Agent')){
                                enrichmentId = id;
                                sectionIdentifier = id;
                                this.setState({sectionId: sectionIdentifier});
                            }
                          }
                        }
                        else
                        {
                          if(enrichmentId === 0 && parseInt(sectionId) === 8 && !sectionTitle.includes('Session')){
                              enrichmentId = id;
                              sectionIdentifier = id;
                              this.setState({sectionId: sectionIdentifier});
                          }
                        }
                        if(subSectionNode.attr.title !== 'Agent' && !sectionTitle.includes('Session') && !sectionTitle.includes('Section')) {
                            let pages = subSectionNode.childrenNamed('page_node').map(pageNode => {
                                const {id, title} = pageNode.attr;
                                return {id, title};
                            });
                            if (getEngagementSurveyStatus() === 0) {
                                pages = pages.filter(p => p.title !== 'Engagement Survey');
                            }
                            if (pages.length > 0) {
                                sections.push({id, title, pages});
                            }
                            if (id === sectionIdentifier) {
                                currentSectionIndex = index + subSectionIndex;
                            }
                        }
                    });
                });
                this.setState({ title, sections, bookStyle, selectedIndex: currentSectionIndex });
                this.selectPage(bookId, sectionIdentifier, pageNum, sections);

            }).catch(err => formatErrors(err, '/assignments'));
        }
    }

    isValidPage(pageNum) {
        return (Number.isInteger(parseInt(pageNum)) && pageNum > 0 && (pageNum <= this.getPagesFromSection().length));
    }

    fetchPage(bookId, sectionId, pageId, pageNum, sessionNum,enrichmentsId) {
        let {moduleURL,studentInput,sections, assignmentInfo, assetID} = this.state;
        const {formatErrors, saveAnswer,role,users} = this.props;

        const {assignmentId='' } = this.props.match.params;

        window.contentparams[1] = String(sessionNum);
        window.contentparams[7] = String(pageNum);

        // if(sessionNum <= 8){
        //   window.contentparams[1] = String(sessionNum);
        // }else{
        //   window.contentparams[1] = String(enrichmentsId);
        // }
        // if(sessionNum <= 8){
        //     window.contentparams[1] = String(sessionNum);
        //   }else if(bookId == '61a65fb3f40f2b31faa5d329'){
        //     window.contentparams[1] = String(sessionNum);
        //   }else{
        //     window.contentparams[1] = String(enrichmentsId);
        //   }

        if(sessionNum <= 12){
            window.contentparams[1] = String(sessionNum);
          }else{
            window.contentparams[1] = String(enrichmentsId);
          }


        localStorage.setItem('contentparams',JSON.stringify(window.contentparams));

        api.fetchContent(bookId, {assignmentId,pageNum,role},window.contentparams).then(result => {
            let studentInput = null;
            if(!isEmpty(result.content.moduleProgress)){
                studentInput = result.content.moduleProgress[0].studentInput;
                if(result.content.moduleProgress.length > 1 &&
                    Object.keys(result.content.moduleProgress[1].studentInput).length >
                    Object.keys(result.content.moduleProgress[0].studentInput).length
                ) { studentInput = result.content.moduleProgress[1].studentInput; }
            }

            window.contentparams[8] = result.content.moduleProgress[0].lastreadpage;

            if(!isEmpty(studentInput) && isEmpty(this.props.answers)) {
                for (const [key, value] of Object.entries(studentInput)) {
                    saveAnswer({[key]: value},users);
                }
            }
            this.setState({
                studentInput: studentInput,
                extendedContentVisible: true,
                pageId: pageId,
                extendedContent: result.content.extendedContentPackage
            });

            this.fetchExtendedContent();
            fetchXML(`${moduleURL}/pages/${pageId}.xml`, studentInput, assignmentInfo).then(xml => {
                let currentPageName = '';
                if(sections[this.state.selectedIndex] && sections[this.state.selectedIndex].pages[parseInt(pageNum)-1] &&
                    !isEmpty(sections[this.state.selectedIndex].pages[parseInt(pageNum)-1]) &&
                    sections[this.state.selectedIndex].pages[parseInt(pageNum)-1].title
                    && !isEmpty(sections[this.state.selectedIndex].pages[parseInt(pageNum)-1].title)) {
                    currentPageName = sections[this.state.selectedIndex].pages[parseInt(pageNum)-1].title;
                }
                const xmlTransform = new XMLTransform(xml, currentPageName, moduleURL, assetID);
                const transformedXML = xmlTransform.transform();
                if (transformedXML) {
                    return transformedXML;
                } else{
                    return xml;
                }
            }).then(xml => {
                const pageNode = xml.childNamed('page_node');

                const textNodesList = pageNode.childrenNamed('text_node') || [];
                const videoNodesList = pageNode.childrenNamed('video_node') || [];
                const imageNodesList = pageNode.childrenNamed('image_node') || [];
                const animatedImageNodesList = pageNode.childrenNamed('animated_image_node') || [];
                const textAreaNodesList = pageNode.childrenNamed('text_area_node') || [];
                const buttonNodesList = pageNode.childrenNamed('button_node') || [];
                const mcNodesList = pageNode.childrenNamed('mc_node') || [];
                const ceNodesList = pageNode.childrenNamed('ce_node') || [];
                const audioNodesList = pageNode.childrenNamed('audio_node') || [];
                const actionButtonNodesList = pageNode.childrenNamed('action_button_node') || [];
                const ddNode = pageNode.childNamed('dd_node') || null;
                const timerNode = pageNode.childNamed('timer_node');
                const assessmentNode = pageNode.childNamed('assessment_node');
                const teNode = pageNode.childNamed('te_node');
                const slideshowNode = pageNode.childNamed('slideshow_node') || null;

                // We collect pageNode's eventNodes in case there is an onPageLoad event.
                const eventNodesList = pageNode.childrenNamed('event_node') || null;

                this.setState({
                    content: {
                        pageId: pageNode.attr.id,
                        textNodesList,
                        videoNodesList,
                        imageNodesList,
                        animatedImageNodesList,
                        textAreaNodesList,
                        buttonNodesList,
                        mcNodesList,
                        ceNodesList,
                        audioNodesList,
                        actionButtonNodesList,
                        ddNode,
                        timerNode,
                        assessmentNode,
                        teNode,
                        slideshowNode,
                        eventNodesList,
                    }
                });

            }).catch(err => formatErrors(err, '/assignments'));

        }).catch(err => formatErrors(err, '/assignments'));
    }

    handleButtonClick(targetPageNum){
        this.setState({targetPageExtendedContent :targetPageNum}, () => this.showUnsavedExtendedContentModal());
    }

    extendedContentHtmlChanged(currentHtml, originalHtml) {
        if(currentHtml !== originalHtml) {
            this.setState({extendedContentModified: true});
        }else{
            this.setState({extendedContentModified: false});
        }
    }

    showUnsavedExtendedContentModal(){
        this.setState({showEditorModalProps: true});
    }

    handleUnsavedExtendedContent(discardExtendedContentChangesBool){
        const {bookId, sections, extendedContentId, selectedIndex, targetPageExtendedContent, extendedContentExitAction, moduleID, extendedContentSectionTarget} = this.state;
        const section = sections[selectedIndex];
        this.setState({showEditorModalProps: false});
        if(discardExtendedContentChangesBool){
            this.setState({extendedContentModified: false,}, () => {
                if(extendedContentExitAction){
                    this.props.history.push(`/modules/${moduleID}`);
                }else if(!isEmpty(extendedContentSectionTarget)){
                    const pageLink = `/view/modules/${moduleID}/sections/${extendedContentSectionTarget.id}/pages/1/extendid/${extendedContentId}?edit`;
                    this.selectPage(moduleID, extendedContentSectionTarget.id, 1, sections);
                    this.props.history.push({pathname: pageLink, search: this.props.history.location.search});
                }else{
                    window.location.href = `/view/modules/${bookId}/sections/${section.id}/pages/${targetPageExtendedContent}/extendid/${extendedContentId}?edit`;
                }
            });
        }else{
            this.setState({extendedContentExitAction: false, extendedContentSectionTarget:{}, targetPageExtendedContent:0});
        }
    }

    // eslint-disable-next-line no-unused-vars
    disableJREAppPlayerContainerButtons(disableActionType, calledFrom){
        /*
        * In order to prevent writing 2 functions each time we want to disable a set of buttons in the JRE,
        *  disableActionType argument was introduced, which is then set as the key for the state boolean we wish
        *  to update, ex, when submitting we pass param "submitting", and then use this value as the key in
        *  setState; when a student is taking an assessment we pass takingAssessment
        *
        * calledFrom used for debugging purposes, console log it to see what Component is setting state
        * console.log({disableActionType, calledFrom});
        * */
        this.setState({[disableActionType]: true});
    }

    // eslint-disable-next-line no-unused-vars
    enableJREAppPlayerContainerButtons(enableActionType, calledFrom){
        /*
        * check disableJREAppPlayerContainerButtons for parameter description
        * */
        this.setState({[enableActionType]: false});
    }

    render() {
        const {
            moduleID, sectionId, pageNum, pageCount, sessionNum, nextBtnDisabled, prevBtnDisabled, sections, content,
            title, selectedIndex, bookStyle = {}, moduleURL, assignmentId, sectionTitle, sectionComplete, latestPage,
            collapsed, showGradingModal, showSuccessModal, pageId, submitting, takingAssessment, preventMultiClick,
            requiredNodeNotCompleted,
        } = this.state;
        let {
            extendedContentVisible, extendedContent, extendedContentEditing = false, extendedContentPreviewing = false,
            showEditorModalProps = false, extendedContentModified = false,} = this.state;
        // eslint-disable-next-line no-unused-vars
        const {role} = this.props; // progress is an Object where each element's key
        // is the student id and each element's value is an array of grade items, when subtype !== 'mathMod' there
        // is only the module grade item, otherwise DD IPL grade items are also present

        //video-player forward seeking prevention :-
        // Same reach check as the sidebar: enabled slides at or before this
        // number are already studied. Forward seek stays blocked only on the
        // newest student slide.
        const lastReadPage = Number(window.contentparams && window.contentparams[8]) || 0;
        const furthestPage = Math.max(Number(latestPage) || 0, lastReadPage);
        window.jreRestrictForwardSeek = role === 'student'
            && !sectionComplete
            && furthestPage > 0
            && Number(pageNum) >= furthestPage;

        /* bookStyle should not be null during rendering. This may ideally be fixed elsewhere (maybe by using setState
        synchronously). */
        if (isEmpty(bookStyle)) {
            return null;
        }
        // Default styling values. All font sizes set in XML appear to be defined in pixels.
        const {
            fontFamily = 'sans-serif',
            color = '#000',
            fontSize = '12',
            fontStyle = 'normal',
            backgroundImage = '',
            height = 0,
            width = 0
        } = bookStyle;
        let extendedSidebarButtonClass = 'extendedButtonRight';
        let maxContainerWidth = 'calc(100vw - 20px) !important';

        const openExtendedSidebar = (extendedContent && !isEmpty(extendedContent)
            && !isEmpty(extendedContent.contentJson)) ? extendedContent.contentJson: '';   // Naren extendedContent.contentJson[pageId]

        if(role === 'student' && isEmpty(openExtendedSidebar) ||
            !(role === 'teacher' || role === 'school_admin' || role === 'student')
        ){
            extendedContent = false;
            extendedContentVisible = false;
        }

        if(extendedContentVisible) {
            maxContainerWidth = 'calc(100vw - 230px) !important';
            extendedSidebarButtonClass = 'extendedButtonLeft ';
        }

        const divStyle = {
            background: `url(${moduleURL}/media/${backgroundImage}) top center repeat-y`,
            color: color,
            fontFamily: fontFamily,
            fontSize: `${fontSize}px`,
            fontStyle: fontStyle,
            height:  `${height}px`,
            maxWidth: maxContainerWidth,
        };
        const bookDivStyle = {
            color: color,
            width: `${width}px`,
            height:  `${height}px`,
            maxWidth: maxContainerWidth,
            margin: '0 auto',
            position: 'relative',
            overflow: 'hidden',
        };
        let pageTitleLink = `/view/modules/${moduleID}`;

        if(role === 'student') { pageTitleLink = `/view/modules/${moduleID}/assignments/${assignmentId}`; }

        let sidebarClassNames = 'plright  animated fadeInRight';
        let arrowButtonClass = 'moduleButtonRight  animated fadeInRight';
        if(collapsed) {
            sidebarClassNames = 'plright hidden';
            arrowButtonClass = 'moduleButtonLeft animated fadeInRight';
        }

        let extendedContentSidebarWidth = width - 20;
        if(!collapsed) {extendedContentSidebarWidth = extendedContentSidebarWidth - 210;}

        const extendedContentStyle = { maxWidth: `calc(100vw - ${extendedContentSidebarWidth}px`, backgroundColor: '#E5E6E7' };

        let currentPageName = '';
        // TODO: change code below to return a bool in a function which we use to determine what to do in if(){}
        //  both here and on lines 304-307
        if(sections[this.state.selectedIndex] && sections[this.state.selectedIndex].pages[parseInt(pageNum)-1] &&
            !isEmpty(sections[this.state.selectedIndex].pages[parseInt(pageNum)-1]) &&
            sections[this.state.selectedIndex].pages[parseInt(pageNum)-1].title
            && !isEmpty(sections[this.state.selectedIndex].pages[parseInt(pageNum)-1].title)) {
            currentPageName = sections[selectedIndex].pages[parseInt(pageNum)-1].title;
        }

        let extendedContentId = null;
        let extendedtextId = null;
        if(extendedContent && !isEmpty(extendedContent) && extendedContent.id) {
            extendedContentId = extendedContent.id;
            extendedtextId=extendedContent.extendtextid;
        }

        return (
            <div>
                {/*
                    inconsistency below, how is one modal rendered through a function and one is hardcoded....
                    such op programming
                */}
                {showGradingModal && this.gradingModal()}

                <SweetAlert
                    show={showSuccessModal}
                    title="Congratulations"
                    text={`You have completed Session ${sessionNum}!`}
                    onConfirm={this.onCloseSuccessModal}
                />

                <Page
                    moduleID={moduleID}
                    role={role}
                    previousPage={this.moveToPreviousPage.bind(this)}
                    nextPage={this.moveToNextPage.bind(this)}
                    nextBtnDisabled={nextBtnDisabled}
                    prevBtnDisabled={prevBtnDisabled}
                    refreshSlide={this.refreshSlide.bind(this)}
                    className="book"
                    pageTitle={title}
                    pageTitleLink={pageTitleLink}
                    pageNum={pageNum}
                    pageCount={pageCount}
                    sessionNum={sessionNum}
                    sectionTitle={sectionTitle}
                    extendedContentEditing={extendedContentEditing}
                    exitViewer={this.exitViewer.bind(this)}
                    collapsed={collapsed}
                    activeSectionPagesList={this.getPagesFromSection()}
                    submitting={submitting}
                    takingAssessment={takingAssessment}
                    preventMultiClick={preventMultiClick}
                    requiredNodeNotCompleted={requiredNodeNotCompleted}
                >
                    <div className="plleft">
                        {(extendedContent && extendedContentVisible && !isEmpty(pageId) && !isEmpty(currentPageName)) &&
                        <ExtendedContentSidebar
                            extendedContentStyle={extendedContentStyle}
                            role={role}
                            contentJson={extendedContent.contentJson}
                            extendedContentId={extendedContent.id}
                            extendedtextId={extendedContent.extendtextid}
                            editing={extendedContentEditing}
                            previewing={extendedContentPreviewing}
                            currentPageId={pageId}
                            pageNum={pageNum}
                            currentPageName={currentPageName}
                            extendedContentHtmlChanged={this.extendedContentHtmlChanged}
                            showEditorModalProps={showEditorModalProps}
                            handleUnsavedExtendedContent={this.handleUnsavedExtendedContent}
                            extendedContentModified={extendedContentModified}
                            enableJREButtonsWhileSubmittingExtendedContent={this.enableJREAppPlayerContainerButtons}
                            disableJREButtonsWhileSubmittingExtendedContent={this.disableJREAppPlayerContainerButtons}
                        />
                        }
                        <div className="book-content-container" style={divStyle}>
                            {extendedContent &&
                            <div className={extendedSidebarButtonClass}
                                 onClick={this.collapseExtendedContentSidebar.bind(this)}/>
                            }
                            <BookContent
                                moduleID={moduleID}
                                sessionNum={sessionNum}
                                pageNum={pageNum}
                                moduleURL={moduleURL}
                                content={content}
                                nextPage={this.moveToNextPage.bind(this)}
                                exitViewer={this.exitViewer.bind(this)}
                                style={bookDivStyle}
                                enableJREAppPlayerContainerButtons={this.enableJREAppPlayerContainerButtons}
                                disableJREAppPlayerContainerButtons={this.disableJREAppPlayerContainerButtons}
                            />
                        </div>
                    </div>
                    <div className={arrowButtonClass} onClick={this.collapseSidebar.bind(this)} />
                    <div className={sidebarClassNames}>
                        {(sections.length > 0) && <BookSidebar
                            assignmentId={assignmentId}
                            role={role}
                            moduleURL
                            sections={sections}
                            bookId={moduleID}
                            sectionComplete={sectionComplete}
                            latestPage={latestPage}
                            sectionTitle={sectionTitle}
                            selectedSectionId={sectionId}
                            selectedPageNum={pageNum}
                            changeSection={this.changeSection.bind(this)}
                            selectedIndex={selectedIndex}
                            extendedContentId={extendedContentId}
                            extendedContentEditing={extendedContentEditing}
                            extendedContentModified={extendedContentModified}
                            handleButtonClick={this.handleButtonClick}
                            submitting={submitting}
                        />}
                    </div>
                </Page>
            </div>
        );
    }
}

Book.propTypes = {
  role: PropTypes.string, //.isRequired
  currentMyAssignment: PropTypes.object, //.isRequired
  users: PropTypes.object             //.isRequired
};

const mapStateToProps = (state,ownProps) => {
    //console.log(state);
    const {currentMyAssignment} = state;
    let users = (state.auth.users.length>0)?state.auth.users:state.answers.users;
    return {
        answers: state.answers.list,
        student_answers: state.answers,
        currentMyAssignment,
        role: (state.auth.users.length>0)?state.auth.users[0].role:state.answers.users[0].role,  //joyson
        //users: arrayToIdKeyedObject(users),
        users:Object.assign({},users)
    };
};

const mapDispatchToProps = (dispatch) => ({
    formatErrors: (err, redirectTo) => dispatch(formatErrors(err, redirectTo)),
    fetchMyAssignment: (id) => dispatch(fetchMyAssignment(id)),
    addFlashMessage: (message, msgType) => dispatch(addFlashMessage(message, msgType)),
    saveAnswers: (answer,users) => dispatch(saveAnswers(answer,users)),
    saveAnswer: (answer,users) => dispatch(saveAnswer(answer,users))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Book);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/book/index.js